
import React, { useCallback, useEffect, useState } from 'react';
import { Page } from '../../components/Page';

import {
  Panel,
  PanelHeader,
  PanelLabel,
  PanelFooter,
} from '../../components/Panel';

import {
  Form,
  Button,
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  Row,
  Column,
  TextInput,
  Checkbox,
} from '@carbon/react';

import { Add, Checkmark, Edit, EditOff, TrashCan } from '@carbon/react/icons';

import { v4 as uuidv4 } from 'uuid';

import './_settings.scss';
import { useDispatch } from 'react-redux';
import { useGetGroupsQuery} from 'services/groups';
import { useCreateGroupMutation, useUpdateGroupMutation, useDeleteGroupMutation } from 'services/group';
import { useConfirmRemoveSomething } from '@/lib/modal';
import { showToast } from 'services/toasts';

export const Groups = () => {

  const {data, isLoading} = useGetGroupsQuery();
  const dispatch = useDispatch();
  const [changed, setChanged] = useState(false);
  const [settings, setSettings] = useState([]);

  const confirmRemoveGroup = useConfirmRemoveSomething("Gruppe entfernen", "Möchten Sie die Gruppe wirklich entfernen?");
  const [createGroup, {isLoading: isCreating}] = useCreateGroupMutation();
  const [updateGroup, {isLoading: isUpdating}] = useUpdateGroupMutation();
  const [deleteGroup, {isLoading: isDeleting}] = useDeleteGroupMutation();

  /*const changeHandle = useCallback(
    (item) => {
      let fa = [...settings];
      if (item.isNew) {
        fa = [...fa, { ...item, model: { ID: item.uuid } }];
      } else {
        console.info('item?', item);
        let newTypes = settings.map((i) =>
          i.model.ID === item.uuid ? { ...item, model: { ID: item.uuid } } : i
        );
        fa = newTypes;
      }
      console.info('settings:', settings);
      console.info('fa:', fa);
      setSettings(fa);
      setChanged(true);
    },
    [settings]
  );*/

  const handleDelete = (item) => {
    console.info("delete", item);

    confirmRemoveGroup(
      () => {
        deleteGroup(item.uuid).then(result => {
          if (result.error && result.error.data) {
            dispatch(showToast({title:"Gruppe löschen", kind:"error", caption: result.error.data}))
            return
          }
          dispatch(showToast({title:"Gruppe löschen", kind:"success", caption: "Gruppe wurde gelöscht"}))
        }).catch(e => {
          dispatch(showToast({title:"Gruppe löschen", kind:"error", caption: "Gruppe konnte nicht gelöscht werden!"}))
        })
      }
    )

  }

  const handleCreate = (item, disableEditingCallback) => {
    createGroup({name: item.name, description: item.description, default: item.default === "on" ? true: false}).then(result => {
      if (result.error && result.error.data) {
        dispatch(showToast({title:"Gruppe erstellen", kind:"error", caption: result.error.data}))
        return
      }
      dispatch(showToast({title:"Gruppe erstellen", kind:"success", caption: "Gruppe wurde erstellt"}))
      disableEditingCallback();
    }).catch(e => {
      dispatch(showToast({title:"Gruppe erstellen", kind:"error", caption: "Gruppe konnte nicht erstellt werden!"}))
    })
  }
  const handleUpdate = (item, disableEditingCallback ) => {
    updateGroup({id: item.uuid, form: {name: item.name, description: item.description, default: item.default === "on" ? true: false}}).then(result => {
      if (result.error && result.error.data) {
        dispatch(showToast({title:"Gruppe ändern", kind:"error", caption: result.error.data}))
        return
      }
      dispatch(showToast({title:"Gruppe ändern", kind:"success", caption: "Gruppe wurde geändert"}))
      disableEditingCallback();
    }).catch(e => {
      dispatch(showToast({title:"Gruppe ändern", kind:"error", caption: "Gruppe konnte nicht geändert werden!"}))
    })
  }

  useEffect(() => {
    if(data?.data) {
      setSettings(data.data);
      setChanged(false);
    }
  }, [data]);

  return (
    <Page pageTitle="Gruppen" hasSideNav isLoading={isLoading || isCreating || isUpdating || isDeleting}>
      <Row>
        <Column md={5}>
          <Row className="small_row">
            <Column md={4}>
              <Panel small>
                <PanelHeader header>Info</PanelHeader>
                <PanelLabel>
                  Gruppen dienen zur Filterung von Elementen und Features für definierte Benutzer / Organisationen
                </PanelLabel>

                <PanelFooter></PanelFooter>
              </Panel>
            </Column>
            <Column md={4}>
              <Panel small>
                <PanelHeader header>Info</PanelHeader>
                <PanelLabel>
                  Das Festlegen der Gruppen erfolgt in den Einstellungen und ist nur als Administrator möglich
                </PanelLabel>

                <PanelFooter></PanelFooter>
              </Panel>
            </Column>
          </Row>
        </Column>
      </Row>
      <Row>
        <Column>
          <Form>
            <Table size="sm">
              <TableHead>
                <TableRow>
                  <TableHeader>Standard</TableHeader>
                  <TableHeader>Name</TableHeader>
                  <TableHeader>Beschreibung</TableHeader>
                  <TableHeader></TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {settings.map((option) => (
                  <GroupsItem
                    uuid={option.model.ID}
                    name={option.name}
                    default={option.default}
                    description={option.description}
                    key={`type_item_${option.model.ID}`}
                    onUpdate={handleUpdate}
                    onDelete={handleDelete}
                  />
                ))}

                <GroupsItem key={`types_item_new`} onUpdate={handleCreate} />
              </TableBody>
            </Table>
          </Form>
        </Column>
      </Row>
    </Page>
  );
};

export const GroupsItem = ({
  uuid: uuidProps,
  name: nameProps,
  default: defaultProps = false,
  description: descriptionProps,
  onUpdate = () => {},
  onDelete = () => {},
}) => {
  const dispatch = useDispatch();

  const [item, setItem] = useState({ name: nameProps, description: descriptionProps, uuid: uuidProps, default: defaultProps });

  const [changed, setChanged] = useState(false);

  const resetInput = useCallback(() => {
    setItem({
      isNew: uuidProps === undefined || uuidProps === null,
      uuid: uuidProps || uuidv4(),
      name: nameProps,
      default: defaultProps,
      description: descriptionProps,
    });

    setChanged(false);
    enableEditing(uuidProps === undefined || uuidProps === null);
  }, [uuidProps, nameProps, defaultProps, descriptionProps]);

  useEffect(() => {
    resetInput();
  }, [resetInput]);

  const [editing, enableEditing] = useState(false);

  const editItem = useCallback(() => {
    enableEditing(true);
  }, [enableEditing]);

  const stopEditing = useCallback(() => {
    enableEditing(false);
    setItem({
      ...item,
      ...{
        name: nameProps,
        description: descriptionProps,
        default: defaultProps,
      },
    });
    setChanged(false);
  }, [enableEditing, setItem, nameProps, descriptionProps, defaultProps, setChanged, item]);

  const handleChangeField = useCallback(
    (field, value) => {
      let newItem = {};
      newItem[field] = value;

      setItem({ ...item, ...newItem });
      setChanged(true);
    },
    [setItem, item, setChanged]
  );

  const handleUpdate = useCallback(() => {
    if (
      item.name !== null &&
      item.name !== undefined &&
      item.name !== '' &&
      item.uuid !== null &&
      item.uuid !== undefined &&
      item.uuid !== ''
    ) {
      onUpdate(item, () => {enableEditing(false)});
      if (item.isNew === true) {
        resetInput();
      }
    }
  }, [onUpdate, item, resetInput, enableEditing]);

  return (
    <TableRow>
      <TableCell>
        <Checkbox
          id={`row_${item.uuid}_default_field`}
          labelText=""
          checked={item.default}
          readOnly={!editing}
          onChange={(e) => handleChangeField('default', e.target.value)} />
      </TableCell>
      <TableCell>
        {editing === true ? (
          <TextInput
            labelText=""
            value={item.name || ''}
            id={`row_${item.uuid}_name_field`}
            onChange={(e) => handleChangeField('name', e.target.value)}
          />
        ) : (
          item.name
        )}
      </TableCell>
      <TableCell>
        {editing === true ? (
          <TextInput
            labelText=""
            value={item.description || ''}
            id={`row_${item.uuid}_description_field`}
            onChange={(e) => handleChangeField('description', e.target.value)}
          />
        ) : (
          item.description
        )}
      </TableCell>

      {item.isNew ? (
        <TableCell>
          <Button
            renderIcon={(props) => <Add size={20} {...props}/>}
            iconDescription="Element hinzufügen"
            hasIconOnly
            size="sm"
            kind="primary"
            onClick={handleUpdate}
          />
        </TableCell>
      ) : (
        <TableCell>
          {editing === false ? (
            <Button
              renderIcon={(props) => <Edit size={20} {...props}/>}
              iconDescription="bearbeiten"
              hasIconOnly
              size="sm"
              kind="primary"
              onClick={editItem}
              className="row_editing_button"
            />
          ) : (
            <>
              <Button
                renderIcon={(props) => <EditOff size={20} {...props}/>}
                iconDescription="bearbeiten abbrechen"
                hasIconOnly
                size="sm"
                kind="primary"
                onClick={stopEditing}
                className="row_editing_button"
              />
              {changed && (
                <Button
                  renderIcon={(props) => <Checkmark size={20} {...props}/>}
                  iconDescription="updaten"
                  hasIconOnly
                  size="sm"
                  kind="primary"
                  onClick={handleUpdate}
                  className="row_editing_button"
                />
              )}
              <Button
                renderIcon={(props) => <TrashCan size={20} {...props}/>}
                iconDescription="entfernen"
                hasIconOnly
                size="sm"
                kind="danger"
                onClick={() => onDelete(item)}
                className="row_editing_button"
              />
            </>
          )}
        </TableCell>
      )}
    </TableRow>
  );
};
